import React from 'react';
import {Platform, StyleSheet, View} from 'react-native';
import {ScreenProps} from 'src/types/Screen';
import Swipeable from 'react-native-gesture-handler/ReanimatedSwipeable';
import RenderRightDelectActions from 'src/components/elements/RenderRightDelectActions';
import {useDeleteSwipe} from '../hooks';
import Settings from 'src/Settings';
import ReferralItemCanteen from './ReferralItemCanteen';
import ReferralItem from './ReferralItem';
import {Referral} from 'src/types/Referral';
import {
  withGlobalize,
  WithGlobalizeProps,
} from '../../../i18n/HOC/withGlobalize';

const RefferalItemSwipeAble = (
  props: ScreenProps &
    WithGlobalizeProps & {
      item: Referral;
      selectedItemIndex: number;
      onDelete?: () => void;
      onPress: () => void;
    },
) => {
  const [
    maxSwipeDistance,
    screenWidth,
    swipeableRef,
    handleSwipeStart,
    handleSwipeEnd,
    handlePress,
  ] = useDeleteSwipe({onPress: props.onPress});

  return (
    <>
      <Swipeable
        enabled={!!props.onDelete}
        onSwipeableWillOpen={handleSwipeStart}
        onSwipeableClose={handleSwipeEnd}
        ref={swipeableRef}
        renderRightActions={(progressAnimatedValue, dragAnimatedValue) => (
          <RenderRightDelectActions
            dragAnimatedValue={dragAnimatedValue}
            onPress={() => {
              swipeableRef.current?.close();
              props.onDelete();
            }}
          />
        )}
        containerStyle={{
          width: Platform.OS === 'web' ? undefined : screenWidth,
        }}
        rightThreshold={maxSwipeDistance}
        overshootRight={false}
      >
        {!Settings.isRefiveAnd365Pay() && (
          <ReferralItemCanteen
            referral={props.item}
            selectedItemIndex={props.selectedItemIndex}
            key={props.item.externalServiceId}
            {...props}
            onPress={() => handlePress()}
          />
        )}
        {Settings.isRefiveAnd365Pay() && (
          <ReferralItem
            referral={props.item}
            selectedItemIndex={props.selectedItemIndex}
            key={props.item.externalServiceId}
            {...props}
            onPress={() => handlePress()}
          />
        )}
      </Swipeable>
      {!Settings.isRefiveAnd365Pay() && (
        <View style={styles.lineWrapper}>
          <View style={styles.line}></View>
        </View>
      )}
    </>
  );
};
const styles = StyleSheet.create({
  lineWrapper: {
    width: '100%',
    paddingHorizontal: 20,
  },
  line: {
    width: '100%',
    borderBottomWidth: 1,
    borderBottomColor: '#9A9A9F',
  },
});
export default withGlobalize(RefferalItemSwipeAble);
